const editorTheme = {
  ltr: "editor-ltr",
  rtl: "editor-rtl",
  placeholder: "editor-placeholder",
  paragraph: "editor-paragraph",
  text: {
    bold: "editor-text-bold",
    italic: "editor-text-italic",
    underline: "editor-text-underline",
    strikethrough: "editor-text-strikethrough",
    underlineStrikethrough: "editor-text-underlineStrikethrough",
  },
};

export default editorTheme;
